export default "__VITE_ASSET__CB0CevRk__"